
export const PAGES = Object.freeze({
    CHECKOUT: '/checkout/process/',
    LIST: '/marketplace/list/'
});

export const PAYMENT_METHODS = Object.freeze({
    CREDIT: 1,
    CASH: 2,
    PAY_LATER: 3,
    PAY_PLAN: 4,
    INVOICE: 5
});


export const DISCOUNTS_TYPES = Object.freeze({
    PERCENT: '1',
    MONEY: '2',
});

export const CATEGORIES_TYPES = Object.freeze({
    CATEGORY: 1,
    HOST: 2,
    COMPETENCES: 3,
    UNIQUE_COURSE: 4,
    CATALOGUE: 5,
    FORMATS: 6
});

export const PRICE_TYPES = Object.freeze({
    PAID: 1,
    FREE: 2,
    PREPAID: 3
});

export const FEE_BEHAVIOR = Object.freeze({
    PASS_FREE: 1,
    ABSORB: 2
});

export const PRIVACY = Object.freeze({
    PRIVATE: 'privacy',
    PUBLIC: 'public'
});

export const CHECKOUT_OPTIONS = Object.freeze({
    SEAT_BLOCKED: 1,
    AFTER_COMPLETING: 2,
});

export const CHECKOUT_TIMER_OPTIONS = Object.freeze({
    DONT_SHOW: null,
    EIGHT_MINS: 8,
    TEN_MINS: 10,
    TWELVE_MINS: 12,
});

export const DEFAULT_CURRENCIES = Object.freeze([
    'AED','AFN','ALL','AMD','ANG','AOA','ARS','AUD','AWG','AZN','BAM','BBD','BDT','BGN','BIF','BMD','BND','BOB','BRL','BSD','BWP','BYN','BZD','CAD','CDF','CHF','CLP','CNY','COP','CRC','CVE','CZK','DJF','DKK','DOP','DZD','EGP','ETB','EUR','FJD','FKP','GBP','GEL','GIP','GMD','GNF','GTQ','GYD','HKD','HNL','HRK','HTG','HUF','IDR','ILS','INR','ISK','JMD','JPY','KES','KGS','KHR','KMF','KRW','KYD','KZT','LAK','LBP','LKR','LRD','LSL','MAD','MDL','MGA','MKD','MMK','MNT','MOP','MRO','MUR','MVR','MWK','MXN','MYR','MZN','NAD','NGN','NIO','NOK','NPR','NZD','PAB','PEN','PGK','PHP','PKR','PLN','PYG','QAR','RON','RSD','RUB','RWF','SAR','SBD','SCR','SEK','SGD','SHP','SLL','SOS','SRD','STD','SZL','THB','TJS','TOP','TRY','TTD','TWD','TZS','UAH','UGX','USD','UYU','UZS','VND','VUV','WST','XAF','XCD','XOF','XPF','YER','ZAR','ZMW'
]);


export default {
    PAYMENT_METHODS,
    DISCOUNTS_TYPES,
    CATEGORIES_TYPES,
    PRICE_TYPES,
    FEE_BEHAVIOR,
    PRIVACY,
    CHECKOUT_OPTIONS,
    CHECKOUT_TIMER_OPTIONS,
    DEFAULT_CURRENCIES,
};